import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch} from 'react-redux'
import { childCount } from '../../../Redux/Slice/AuthSlice';
import "./ChildQuestion.css"

const ChildQuestion = () => {
  const [childCounts,setChildCounts] = useState()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleChildCount = (e)=>{
    e.preventDefault()
    dispatch(childCount(JSON.stringify(childCounts)))
    navigate('/portal/booking/subscription/membership')
  }

  return (
    <div className='portal-kiga-childQuestion-1-main'>
      <Navbar/>
      <section className='portal-kiga-childQuestion-1-section'>
       <div className='portal-kiga-childQuestion-1-section-header'>
        <p>how many child do Your want to Pay For?</p>
       </div>
       <div className='portal-kiga-childQuestion-1-section-btn-no'>
         <input type='number' onChange={(e)=>setChildCounts(e.target.value)}/>
       </div> 
       <div className='portal-kiga-childQuestion-1-section-btn-yes' onClick={handleChildCount}>
        <p>Next</p>   
       </div>
      </section>
    </div>
  )
}

export default ChildQuestion